export default {
  data() {
    return {
      prevZoom: 1,
      zoomable: true,
      zoomRange: [1, 1]
    };
  },
  methods: {
    forbidZoom(e) {
      if(this.zoomRange[0] == 1 && this.zoomRange[1] == 1){
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        };
      }
    },
    calcZoom () {
      try {
        const innerWidth = window.innerWidth;
        let zoom = 1;
        let scale = 1920 / innerWidth;
        if(scale < (this.zoomRange[0] || 1)) { //0.75
          zoom = innerWidth / (1920 / this.zoomRange[0]);
        } else if(scale > (this.zoomRange[1] || 1)){ // 1.25
          zoom = innerWidth / (1920 / this.zoomRange[1]);
        }
        console.log('zoom>>>', zoom, scale);
        let chromeZoomMinVersion = this.$global.getCustomConfig()['KIAF_CHROME_ZOOM_MIN_VERSION'] || 83;
        if(this.$util.getChromeVersion() >= chromeZoomMinVersion){
          document.documentElement.style.fontSize = '20px';
        }
        if(this.prevZoom != zoom) {
          this.prevZoom = zoom;
          let body = document.querySelector('body');
          body.style.zoom = zoom;
          Object.defineProperty(MouseEvent.prototype, 'pageX', {
            get: function () {
              return this.x / zoom;
            }
          });
          Object.defineProperty(MouseEvent.prototype, 'pageY', {
            get: function () {
              return this.y / zoom;
            }
          });
          Object.defineProperty(MouseEvent.prototype, 'clientX', {
            get: function () {
              return this.x / zoom;
            }
          });
          Object.defineProperty(MouseEvent.prototype, 'clientY', {
            get: function () {
              return this.y / zoom;
            }
          });
          // Object.defineProperty(MouseEvent.prototype, 'offsetX', {
          //   get: function () {
          //     return this.layerX / scale;
          //   }
          // });
          // Object.defineProperty(MouseEvent.prototype, 'offsetY', {
          //   get: function () {
          //     return this.layerY / scale;
          //   }
          // });
          let docOffsetWidth = document.documentElement.offsetWidth;
          let docOffsetHeight = document.documentElement.offsetHeight;
          Object.defineProperty(document.documentElement, 'offsetWidth', {
            get: function () {
              return docOffsetWidth / zoom;
            }
          });
          Object.defineProperty(document.documentElement, 'offsetHeight', {
            get: function () {
              return docOffsetHeight / zoom;
            }
          });
        }
      } catch (e) {
        console.error('calczoom>>>', e);
      }
    }
  },
  created() {
    if(this.customize && (this.customize.zoomable || this.customize.scaleable)){
      this.zoomable = this.customize.zoomable || this.customize.scaleable;
    }
    if(this.customize && this.customize.zoomRange){
      this.zoomRange = this.customize.zoomRange;
    }
    if(this.zoomable){
      this.calcZoom();
    }
  },
  mounted() {
    if(this.zoomable){
      window.addEventListener('mousewheel', this.forbidZoom, { passive: false });
      if(this.$util.getChromeVersion() >= 88){
        window.addEventListener('resize', this.calcZoom);
        setTimeout(() => {
          this.calcZoom();
        }, 1000);
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcZoom);
    window.removeEventListener('mousewheel', this.forbidZoom);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calcZoom);
    window.removeEventListener('mousewheel', this.forbidZoom);
  }
};
